<template>
    <div>
        <MobileHomepage v-if="isMobile" />
        <b-card v-else :class="isShowPanelInfo ? 'home' : 'home home-no-panel-info'">
            <b-row>
                <b-col sm="12" md="8" lg="9" class="mt-sm-2 mt-0">
                    <b-row class="home-panel-info d-sm-flex d-md-none" v-if="isShowPanelInfo">
                        <b-col cols="6">
                            <home-panel-info @click.native="showPanelInfo('inbox')" title="My Inbox" :counter="inboxCount != null ? inboxCount.allInbox : 0" :busy="isInboxCountBusy"/>
                        </b-col>
                        <b-col cols="6">
                            <home-panel-info @click.native="showPanelInfo('submission')" title="My Submission"  :counter="submissionCount != null ? submissionCount.allInbox : 0" :busy="isSubmissionCountBusy" panelType="submission" />
                        </b-col>
                    </b-row>
                    <b-row v-if="!isShowPanelInfo">
                        <b-col cols="12" md="6" v-if="isShowPanelInfoInbox">
                            <b-button class="d-sm-flex p-0 mb-2 btn-panel-back" variant="transparent" @click="hidePanelInfo()"><b-icon icon="arrow-left" /></b-button>
                            <home-inbox :inboxes="inboxes" title="My Inbox" :busy="isInboxCountBusy" />
                        </b-col>
                        <b-col cols="12" md="6" v-if="isShowPanelInfoSubmission" class="mt-sm-3 mt-md-0">
                            <b-button class="d-sm-flex p-0 mb-2 btn-panel-back" variant="transparent" @click="hidePanelInfo()"><b-icon icon="arrow-left" /></b-button>
                            <home-submission :submissions="submissions" title="My Submission" :busy="isSubmissionCountBusy" />
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 d-sm-none d-md-flex">
                        <b-col cols="12">
                            <b-card>
                                <template #header>
                                    <h6 class="mb-0">Posters</h6>
                                </template>
                                <b-card-body>
                                    <b-img :src="`${publicPath}/img/app-poster.jpeg`" fluid-grow></b-img>
                                </b-card-body>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="4" lg="3" class="mt-sm-2 mt-0" v-if="isShowPost">
                    <home-post :posts="posts" title="Posts" :busy="isDataLoading" />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<style lang="scss" scoped>
::v-deep .table thead th {
    font-weight: bold;
}

@media(min-width:576px){
    .btn-panel-back {
        display: none !important;
    }
}
@media(max-width:575px){
    .btn-panel-back {
        display: flex;
    }
}
</style>
<script>
import HomeInbox from './components/HomeInbox.vue';
import HomeSubmission from './components/HomeSubmission.vue';
import HomePost from './components/HomePost.vue';
import HomePanelInfo from './components/HomePanelInfo.vue';
import Post from '@/models/Post/Post';
import MobileHomepage from './Mobile.vue';

export default {
    components : {HomeInbox, HomeSubmission, HomePost, HomePanelInfo, MobileHomepage},
    name: 'Home',
    methods : {
        getInboxAndSubmissions(){
            this.isInboxCountBusy = true;
            this.isSubmissionCountBusy = true;
            this.$http.get(process.env.VUE_APP_API_URL +'home/inboxandsubmissioncount').then(result => {
                let inboxCountObj = result.data.inboxCount;
                let submissionCountObj = result.data.submissionCount;

                this.inboxCount = inboxCountObj;
                this.inboxes = result.data != null ? inboxCountObj.inboxes : [];

                this.submissionCount = submissionCountObj;
                this.submissions = result.data != null ? submissionCountObj.inboxes : [];

                this.isInboxCountBusy = false;
                this.isSubmissionCountBusy = false;
            }).catch(error => {
				this.isInboxCountBusy = false;
                this.isSubmissionCountBusy = false;
			});
        },
        getInboxDetails() {
            this.isInboxCountBusy = true;
            this.$http.get(process.env.VUE_APP_API_URL +'home/inboxcount').then(result => {
                this.inboxCount = result.data;
                this.inboxes = result.data != null ? result.data.inboxes : [];
                this.isInboxCountBusy = false;
            }).catch(error => {
				this.isInboxCountBusy = false;
			});
        },
        getMySubmissionDetails() {
            this.isSubmissionCountBusy = true;
            this.$http.get(process.env.VUE_APP_API_URL +'home/submissioncount').then(result => {
                this.submissionCount = result.data;
                this.submissions = result.data != null ? result.data.inboxes : [];
                this.isSubmissionCountBusy = false;
            }).catch(error => {
				this.isSubmissionCountBusy = false;
			});
        },
        getPosts : async function() {
			this.isDataLoading = true;
			let sortingBy = Array();
			let filter = {};
            let currentPage = 1;
			Post.getList(this, filter, sortingBy, (currentPage - 1), 0)
			.then(result => {
				if (result != null) {
					this.posts = result.data
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
        onResize() {
            this.windowWidth = window.innerWidth;
            if (this.windowWidth <= 576) {
                this.isShowPanelInfo = true;
                this.isShowPanelInfoInbox = false;
                this.isShowPanelInfoSubmission = false;
                this.isShowPost = true;
                this.isMobile = true;
            } else {
                this.isShowPanelInfo = false;
                this.isShowPanelInfoInbox = true;
                this.isShowPanelInfoSubmission = true;
                this.isShowPost = true;
                this.isMobile = false;
            }
        },
        showPanelInfo(panelType) {
            this.isShowPanelInfo = false;
            this.isShowPost = false;
            if (panelType == 'inbox') {
                this.isShowPanelInfoInbox = true;
            }
            if (panelType == 'submission') {
                this.isShowPanelInfoSubmission = true;
            }
        },
        hidePanelInfo() {
            this.isShowPanelInfo = true;
            this.isShowPost = true;
            this.isShowPanelInfoInbox = false;
            this.isShowPanelInfoSubmission = false;
        }
    },
    data() {
      return {
        isShowPanelInfo: false,
        isShowPanelInfoInbox: false,
        isShowPanelInfoSubmission: false,
        isShowPost: true,
        windowWidth: 0,
        isInboxCountBusy: false,
        inboxCount: 0,
        inboxes: [],
        isSubmissionCountBusy: false,
        submissionCount: 0,
        submissions: [],
        isDataLoading: false,
        isMobile: false,
        posts: [],
        menus: []
      }
    },
    beforeMounted() {
        this.onResize();
    },
    mounted() {
        let breadcrumb = [];
        this.$store.dispatch('setBreadCrumb', breadcrumb);

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            this.onResize();

            this.getInboxAndSubmissions();
            this.getPosts();
        });
    },
    computed: {
    }
}
</script>